import { Tooltip } from '@mui/material';
import { TinyVariant } from '@shared/constants/components/tinyUtils';
import { IconName } from '../images/IconMap';
import Icons from '../images/Icons';
import SrOnlyText from '../text/SrOnlyText';
import { BoldTinyText, TinyRow, TinyText } from './CommonTinyStyles';

interface ITinyValuesProps {
    /** The number (or short measure) that leads the row. */
    value: string | number;
    /** What the value is — reads as its unit, e.g. "12 tools". */
    title: string;
    hideLabel?: boolean;
    tooltip?: string;
    icon?: IconName;
    iconSize?: number;
    variant?: TinyVariant;
}

/**
 * A figure and the thing it counts, in that order: **12** tools, **~1.4k** tokens. The value leads in bold
 * so a row of these scans down the numbers, which is the point when they sit side by side.
 *
 * The mirror of {@link TinyLabel}, which leads with the title for "Model: gemma-4" style metadata. Same
 * row, same variants — pick by which half the reader is looking for. (TinyTag also puts the value first,
 * but it's the tag-shaped member of the family, for one-word states rather than measurements.)
 */
export default function TinyValues({
    value,
    title,
    hideLabel,
    tooltip,
    icon,
    iconSize,
    variant = 'diminished',
}: Readonly<ITinyValuesProps>) {
    const row = (
        <TinyRow $variant={variant} title={hideLabel && !tooltip ? title : undefined}>
            {icon && <Icons weight="bold" name={icon} size={iconSize || 14} />}
            <BoldTinyText>{value}</BoldTinyText>
            {hideLabel ? <SrOnlyText>{title}</SrOnlyText> : <TinyText>{title}</TinyText>}
        </TinyRow>
    );

    if (!tooltip) return row;

    return (
        <Tooltip title={tooltip} arrow>
            {row}
        </Tooltip>
    );
}
